// extracted by mini-css-extract-plugin
export var alertIcon = "_un-0";